import { LogoHelper, LogoHelperLong } from '@alliance/shared/icons'

export const logoHelper = LogoHelper
export const logoHelperLong = LogoHelperLong
